import {useCallback, useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import XDate from 'xdate';
import {
  selectEnd,
  selectIsEndDateBeforeStartDate,
  selectStart,
  selectTimezone,
} from '~/CreateFabricInvitation/reducers/details/selectors';
import {StartEnd} from '~/CreateFabricInvitation/routes/EventDetails/components';
import {useFormValidations} from '~/common/FabricInvitation/hooks/useFormValidations';
import {validateStartEnd} from '~/common/FabricInvitation/utils/validation';
import {CustomInputWithIcon} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/CustomInputWithIcon/CustomInputWithIcon';

export const WhenFields = () => {
  const ref = useRef<HTMLDivElement>(null);
  const start: string | null = useSelector(selectStart);
  const end = useSelector(selectEnd);
  const timezone = useSelector(selectTimezone);
  const timeError = useSelector(selectIsEndDateBeforeStartDate);
  const [errorMessage, setErrorMessage] = useState<string | boolean>(timeError);
  const [showOverlay, setShowOverlay] = useState(false);

  const toggleOverlay = useCallback(() => setShowOverlay((prevState) => !prevState), []);

  let value = '';
  const formatDate = (date: string | null) =>
    date ? `${new XDate(date).toString('MMMM dd, yyyy, h:mm TT')} ${timezone}` : null;
  const startDateAndTime = formatDate(start);
  const endDateAndTime = formatDate(end);
  if (startDateAndTime) {
    value = endDateAndTime ? `${startDateAndTime} to \n${endDateAndTime}` : startDateAndTime;
  }

  const validate = useCallback(() => {
    const error = validateStartEnd(start, end, ref.current);
    setErrorMessage(error?.getMessage() ?? false);
    return error;
  }, [start, end]);

  useEffect(() => {
    validate();
  }, [validate]);

  useFormValidations('date', validate);

  return (
    <StartEnd
      scrollContainerSelector=".event-create-design.scrollable"
      controllerOpen={showOverlay}
      onControllerOpenChange={setShowOverlay}
      TriggerElement={
        <CustomInputWithIcon
          id="start-end-time"
          ref={ref}
          name="start-end-time"
          dataQaId="edit-eventstartdate"
          error={errorMessage}
          type="text"
          value={value}
          placeholder="Event date and time"
          onClick={toggleOverlay}
          showEditIcon={false}
          fullWidth
        />
      }
    />
  );
};
